import React from 'react';
import ReportsHub from '@pages/Common/ReportsHub/ReportsHub';
import SuperAdminReportsAnalytics from './ReportAnalytics';

const SuperAdminReportsHub: React.FC = () => <ReportsHub ReportsComponent={SuperAdminReportsAnalytics} />;

export default SuperAdminReportsHub;
